module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-neubau-2c1bcf7b1543594eff1c0a5f276d9e80.svg";